import styled, { css } from "styled-components";
import { motion } from "framer-motion";
import { COLORS, getColorByService } from "../../../../../../../../../../styles";
import {
	CircleBackground,
	CircleMainBackground,
	CircleProgress,
} from "../../../../../../../../CircleProgressBar/CircleProgressBar.styled";
import { ServiceName } from "../../../../../../../../../../constants";

export const LI_Container = styled(motion.div)``;

interface LI_WrapperProps {
	$service: ServiceName;
	$disabled: boolean;
	$color: string;
}

export const LI_Wrapper = styled.div<LI_WrapperProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 50px;
	height: 50px;
	border-radius: 10px;
	border: 2px solid transparent;
	cursor: pointer;

	transition: transform 0.22s ease, border-color 0.22s ease, background 0.22s ease, box-shadow 0.22s ease,
		filter 0.22s ease;
	will-change: transform, box-shadow;

	${(props) => {
		const color = getColorByService(props.$service);

		return css`
			color: ${["#ffffff"].includes(props.$color) ? COLORS.Dark_Gray : COLORS.White};

			&:hover {
				transform: translateY(-2px) scale(1.02);
				border-color: ${color};
			}

			&:active {
				transform: translateY(0) scale(0.98);
			}
		`;
	}}
	&.active {
		${(props) => css`
			background: ${getColorByService(props.$service)};

			${CircleProgress} {
				stroke: ${COLORS.Dark_Gray};
			}

			${CircleBackground} {
				stroke: ${COLORS.White};
			}
		`}
	}

	${(props) => {
		const color = getColorByService(props.$service);

		return css`
			${CircleMainBackground} {
				fill: ${color};
			}

			${CircleProgress} {
				stroke: ${color};
			}

			${CircleBackground} {
				stroke: ${COLORS.MidGray};
			}
		`;
	}}

	${(props) =>
		props.$disabled &&
		css`
        filter: grayscale(60%);
        cursor: not-allowed;
      !important;

        svg {
          cursor: not-allowed;
        !important;
        }

        &:hover {
          border-color: transparent;
          transform: translateY(0) scale(1);
        }
      `}
`;

export const LI_Lock = styled.div`
	position: absolute;
	right: 4px;
	bottom: 1.5px;
	color: ${COLORS.Dark_Gray};

	svg {
		width: 13px;
		height: 13px;

		rect {
			fill: ${COLORS.Dark_Gray};
		}

		path {
			stroke: ${COLORS.Dark_Gray};
		}
	}
`;
